import React from "react";
import _ from "lodash";
import ReactTooltip from "react-tooltip";
import PriceUnit from "./PriceUnit";
import PriceLimitHint from "./PriceLimitHint";
import ClickToCopyWrapper from "../../../common/ClickToCopyWrapper";

import { FiInfo } from "react-icons/fi";
import { isPricesInvalid } from "./UPRSegmentationHelper";

class PriceSettingInput extends React.Component {
  constructor(props) {
    super(props);

    const { prices, preventInitCheck = true } = this.props;

    this.state = {
      inputValue: prices.map((d) => (d === null ? "null" : d)).join(","),
      prices,

      preventInitCheck,
      isInvalid: false,
      isInputValid: true,
      errMsg: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.isPricesInvalid = this.isPricesInvalid.bind(this);
    this.validateString = this.validateString.bind(this);
  }

  componentDidMount() {
    if (this.props.prices) {
      this.isPricesInvalid(this.props.prices);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.limit, this.props.limit)) {
      this.isPricesInvalid(this.state.prices);
    }

    if (!_.isEqual(prevState.prices, this.state.prices)) {
      if (this.props.handleSync) {
        this.props.handleSync(this.state.prices);
      }
    }
  }

  handleInputChange(e) {
    const value = e.target.value;
    this.setState({ inputValue: value });

    let items = [];

    if (value !== "") {
      if (this.validateString(value)) {
        items = value.split(",").map((s) => {
          return s.trim() === "null" ? null : parseFloat(s.trim());
        });
      } else {
        this.setState({ isInputValid: false });
        return;
      }
    }

    this.setState({ preventInitCheck: false }, () => {
      this.isPricesInvalid(items);
      this.setState({ prices: items, isInputValid: true });
    });
  }

  isPricesInvalid(prices) {
    const { limit } = this.props;
    const { isInvalid, errMsg } = isPricesInvalid({ prices, limit });
    if (!this.state.preventInitCheck) this.setState({ isInvalid, errMsg });
    if (this.props.handleValidChanged) {
      this.props.handleValidChanged(!isInvalid);
    }
  }

  validateString(str) {
    const { supportAlgo = false } = this.props;
    const parts = str.split(",").map((s) => s.trim());

    const numberRegex = /^[+-]?(\d+(\.\d+)?|\.\d+)$/;

    return parts.every((part) => {
      if (part === "null" && supportAlgo) return true;
      if (numberRegex.test(part)) return true;
      return false;
    });
  }

  render() {
    const { inputValue, prices, isInvalid, errMsg, isInputValid } = this.state;
    const {
      limit = {},
      supportAlgo = false,
      showTooltip = true,
      showErrMsg = true,
    } = this.props;

    return (
      <>
        <PriceLimitHint limit={limit}></PriceLimitHint>
        <div className="border rounded border-gray-400 bg-gray-200 p-2">
          <div className="flex flex-wrap items-center gap-2">
            {prices.map((p, idx) => {
              return (
                <PriceUnit
                  price={p}
                  key={`${idx}-${p}`}
                  readOnly={true}
                  tooltip={showTooltip ? idx + 1 : undefined}
                ></PriceUnit>
              );
            })}
            {prices.length === 0 ? (
              <div className="text-sm text-gray-400">No prices set</div>
            ) : (
              <ClickToCopyWrapper
                copyText={prices.join(",")}
                tooltipMessage="Copy prices"
              ></ClickToCopyWrapper>
            )}
          </div>
        </div>
        <div className="text-xs text-gray-700">
          {(prices && prices.length) || 0} prices
        </div>
        {isInvalid && showErrMsg && (
          <div className="bg-red-100 px-2 font-semibold text-red-700">
            {errMsg}
          </div>
        )}
        <div className="mt-2 flex items-center gap-2">
          <span className="text-sm">
            Use <b>comma</b> to separate price value.
          </span>
          <span className="cursor-pointer text-lg text-blue-600">
            <FiInfo data-tip data-for="price-variation"></FiInfo>
          </span>
          <ReactTooltip
            id="price-variation"
            type="dark"
            effect="solid"
            place="right"
          >
            <div>-1 for no upr.</div>
            <div>-2 for LGO.</div>
            <div>
              p {`>=`} 1000000 for target ecpm. (transform with (p -
              1000000)/100)
            </div>
            <div>0 ... {`<`}1000000 for floor price.</div>
            {supportAlgo && <div>null for algorithm.</div>}
          </ReactTooltip>
        </div>
        {supportAlgo ? (
          <div className="flex items-center text-sm text-gray-700">
            ex. null,null,null,null,null,null,-1,-1,-2,-2,1000025,15, 10, 10,
            5,5, -1,-1, -2, -2, null, null, null, null
            <ClickToCopyWrapper
              copyText={
                "null,null,null,null,null,null,-1,-1,-2,-2,1000025,15, 10, 10,5,5, -1,-1, -2, -2, null, null, null, null"
              }
            ></ClickToCopyWrapper>
          </div>
        ) : (
          <div className="flex items-center text-sm text-gray-700">
            ex. -1, -1, -2, -2 ,5,0, 1000025, 1000025, 1000020, 1
            <ClickToCopyWrapper
              copyText={"-1, -1, -2, -2 ,5,0, 1000025, 1000025, 1000020, 1"}
            ></ClickToCopyWrapper>
          </div>
        )}
        <textarea
          className="border rounded w-full border-gray-400 p-2"
          value={inputValue}
          onChange={this.handleInputChange}
          rows={3}
        ></textarea>
        {!isInputValid && (
          <div className="bg-red-100 px-2 font-semibold text-red-700">
            Input text is invalid. Please reference the example above.
          </div>
        )}
      </>
    );
  }
}

export default PriceSettingInput;
